import {Parcel} from './Parcel';

const types = [
    {value: 1, type: 'paczka', label: 'Paczka'},
    {value: 2, type: 'koperta', label: 'Koperta'},
    {value: 3, type: 'paleta', label: 'Paleta'}
];

export const ParcelType = {
    name: 'ParcelType',
    components: {
        Parcel
    },
    props: {
        value: [String, Number],
        size: String,
        name: {
            type: String,
            default: 'parcel-type'
        }
    },
    computed: {
        types() {
            return types
        }
    },
    template: `
        <div class="parcel-type__set">
            <template v-for="type in types">
                 <div class="parcel-type__set__item">
                     <input type="radio" 
                            :id="'parcel-type-id-'+type.value" 
                            :name="name"
                            class="parcel-type__radio"
                            :checked="value == type.value"
                            @change="$emit('input', type.value)"
                            :value="type.value"/>
                    <Parcel :isSelectable="true"
                            :size="size"
                            :for="'parcel-type-id-'+type.value" 
                            :type="type.type" :label="type.label"/>
                 </div>
            </template>
        </div>
    `
}